import jQuery from "jquery";

const $ = jQuery;

export default function(selector) {
  $(function() {
    $(`${selector} span.next a`).html("nächste Seite <i class='icon-collection ic-arrow-right'></i>");
  });
}